// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const LockIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="LockIcon" ref={forwardedRef} {...props}>
      <path d="M9.25 11h1.5v3h-1.5z" />
      <path d="M14.746 8V7a3 3 0 0 0-3-3h-3.5a3 3 0 0 0-3 3v1H4.5a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zm-3-2.5a1.5 1.5 0 0 1 1.5 1.5v1h-6.5V7a1.5 1.5 0 0 1 1.5-1.5zM5 9.5h10v6H5z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const LockIcon = /* @__PURE__ */ Object.assign(LockIconComponent, {
  displayName: 'LockIcon',
});
